module.exports = function findConfigFromType(type, configs) {
	let config;
	for (const [a_type, a_config] of Object.entries(configs)) {
		if (a_type === type) {
			config = a_config;
			break;
		}
	}
	return config;
};
